// resolveDrag — turn a dnd-kit drag-end into the arrange action to perform (#86bb5dx62).
//
// One DndContext hosts two drag sources over the same tile droppables:
//   • a TILE dragged onto another tile      → swap the two slots
//   • a CAMERA dragged from the Arrange tree → assign it into the dropped-on slot
//
// The source is distinguished by active.data.current.type ('tree-camera' vs a tile,
// which carries an absIndex). Returns one of:
//   { kind: 'swap',   from, to }      | { kind: 'assign', slot, camera } | null
export const resolveDrag = (active, over) => {
  if (!active || !over) return null;
  const a = active.data && active.data.current;
  const o = over.data && over.data.current;
  if (!a || !o || o.absIndex == null) return null;

  if (a.type === 'tree-camera') {
    if (!a.camera) return null;
    return { kind: 'assign', slot: o.absIndex, camera: a.camera };
  }

  // Tile → tile swap (ignore a no-op drop onto itself).
  if (a.absIndex == null || a.absIndex === o.absIndex) return null;
  return { kind: 'swap', from: a.absIndex, to: o.absIndex };
};
